/* @flow */
import * as React from 'react';

import Image from './Image';

const ILLUSTRATIONS = {
  'female-customer-handshake': {
    width: 730,
    '1x': require('../../../assets/images/illustrations/female-customer-handshake.png'),
    '2x': require('../../../assets/images/illustrations/female-customer-handshake_2x.png'),
  },
  'female-customer-rate-and-tip': {
    width: 612,
    '1x': require('../../../assets/images/illustrations/female-customer-rate-and-tip.png'),
    '2x': require('../../../assets/images/illustrations/female-customer-rate-and-tip_2x.png'),
  },
  'female-customer-luggers-loading': {
    width: 1044,
    '1x': require('../../../assets/images/illustrations/female-customer-luggers-loading.png'),
    '2x': require('../../../assets/images/illustrations/female-customer-luggers-loading_2x.png'),
  },
  'craigslist-purchase': {
    width: 917,
    '1x': require('../../../assets/images/illustrations/craigslist-purchase.png'),
    '2x': require('../../../assets/images/illustrations/craigslist-purchase_2x.png'),
  },
  'male-customer-rate-and-tip': {
    width: 472,
    '1x': require('../../../assets/images/illustrations/male-customer-rate-and-tip.png'),
    '2x': require('../../../assets/images/illustrations/male-customer-rate-and-tip_2x.png'),
  },
  'luggers-moving-couch': {
    width: 554,
    '1x': require('../../../assets/images/illustrations/luggers-moving-couch.png'),
    '2x': require('../../../assets/images/illustrations/luggers-moving-couch_2x.png'),
  },
  'hand-with-couch': {
    width: 618,
    '1x': require('../../../assets/images/illustrations/hand-with-couch.png'),
    '2x': require('../../../assets/images/illustrations/hand-with-couch_2x.png'),
  },
  'moving-with-pickup': {
    width: 964,
    '1x': require('../../../assets/images/illustrations/moving-with-pickup.png'),
    '2x': require('../../../assets/images/illustrations/moving-with-pickup_2x.png'),
  },
  'moving-with-van': {
    width: 964,
    '1x': require('../../../assets/images/illustrations/moving-with-van.png'),
    '2x': require('../../../assets/images/illustrations/moving-with-van_2x.png'),
  },
  'moving-with-xl': {
    width: 964,
    '1x': require('../../../assets/images/illustrations/moving-with-xl.png'),
    '2x': require('../../../assets/images/illustrations/moving-with-xl_2x.png'),
  },
  'moving-into-storage': {
    width: 960,
    '1x': require('../../../assets/images/illustrations/moving-into-storage.png'),
    '2x': require('../../../assets/images/illustrations/moving-into-storage_2x.png'),
  },
  'moving-into-public-storage': {
    width: 816,
    '1x': require('../../../assets/images/illustrations/moving-into-public-storage.png'),
    '2x': require('../../../assets/images/illustrations/moving-into-public-storage_2x.png'),
  },
  'moving-into-extra-space-storage': {
    width: 816,
    '1x': require('../../../assets/images/illustrations/moving-into-extra-space-storage.png'),
    '2x': require('../../../assets/images/illustrations/moving-into-extra-space-storage_2x.png'),
  },
  'bed-with-tools': {
    width: 201,
    '1x': require('../../../assets/images/illustrations/bed-with-tools.png'),
    '2x': require('../../../assets/images/illustrations/bed-with-tools_2x.png'),
  },
  'tv-with-plates': {
    width: 223,
    '1x': require('../../../assets/images/illustrations/tv-with-plates.png'),
    '2x': require('../../../assets/images/illustrations/tv-with-plates_2x.png'),
  },
  'luggers-loading-junk': {
    width: 1027,
    '1x': require('../../../assets/images/illustrations/luggers-loading-junk.png'),
    '2x': require('../../../assets/images/illustrations/luggers-loading-junk_2x.png'),
  },
  'vehicle-lineup': {
    width: 924,
    '1x': require('../../../assets/images/illustrations/vehicle-lineup.png'),
    '2x': require('../../../assets/images/illustrations/vehicle-lineup_2x.png'),
  },
  'vehicle-lineup-small': {
    width: 471,
    '1x': require('../../../assets/images/illustrations/vehicle-lineup-small.png'),
    '2x': require('../../../assets/images/illustrations/vehicle-lineup-small_2x.png'),
  },
  'luggers-broken-truck': {
    width: 960,
    '1x': require('../../../assets/images/illustrations/luggers-broken-truck.png'),
    '2x': require('../../../assets/images/illustrations/luggers-broken-truck_2x.png'),
  },
  'luggers-moving-home': {
    width: 1108,
    '1x': require('../../../assets/images/illustrations/luggers-moving-home.png'),
    '2x': require('../../../assets/images/illustrations/luggers-moving-home_2x.png'),
  },
  'luggers-moving-junk': {
    width: 962,
    '1x': require('../../../assets/images/illustrations/luggers-moving-junk.png'),
    '2x': require('../../../assets/images/illustrations/luggers-moving-junk_2x.png'),
  },
  'luggers-with-furniture': {
    width: 444,
    '1x': require('../../../assets/images/illustrations/luggers-with-furniture.png'),
    '2x': require('../../../assets/images/illustrations/luggers-with-furniture_2x.png'),
  },
  'luggers-with-boxes': {
    width: 477,
    '1x': require('../../../assets/images/illustrations/luggers-with-boxes.png'),
    '2x': require('../../../assets/images/illustrations/luggers-with-boxes_2x.png'),
  },
  'luggers-moving-generic': {
    width: 1156,
    '1x': require('../../../assets/images/illustrations/luggers-moving-generic.png'),
    '2x': require('../../../assets/images/illustrations/luggers-moving-generic_2x.png'),
  },
  'luggers-with-items-and-xl': {
    width: 1240,
    '1x': require('../../../assets/images/illustrations/luggers-with-items-and-xl.png'),
    '2x': require('../../../assets/images/illustrations/luggers-with-items-and-xl_2x.png'),
  },
  'booking-calendar': {
    width: 360,
    '1x': require('../../../assets/images/illustrations/booking-calendar.png'),
    '2x': require('../../../assets/images/illustrations/booking-calendar_2x.png'),
  },
  'checked-furniture': {
    width: 399,
    '1x': require('../../../assets/images/illustrations/checked-furniture.png'),
    '2x': require('../../../assets/images/illustrations/checked-furniture_2x.png'),
  },
  'mobile-booking-calendar': {
    width: 320,
    '1x': require('../../../assets/images/illustrations/mobile-booking-calendar.png'),
    '2x': require('../../../assets/images/illustrations/mobile-booking-calendar_2x.png'),
  },
};

export type IllustrationID = $Keys<typeof ILLUSTRATIONS>;

function Illustration({
  name,
  style,
  className,
}: {
  name: IllustrationID,
  style?: ?Object,
  className?: ?string,
}) {
  let illustration = ILLUSTRATIONS[name];

  return (
    <Image
      src={illustration['1x']}
      src2x={illustration['2x']}
      alt={name}
      style={{ width: '100%', maxWidth: illustration['width'], ...style }}
      className={className}
    />
  );
}

export default Illustration;



// WEBPACK FOOTER //
// ./src/ui/components/core/Illustration.js